import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Tile, InlineNotification, Loading, Tag } from '@carbon/react';
import { getDocumentByToken } from '@/lib/documentsApi';

const TimesheetViewPage = () => {
  const { token } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getDocumentByToken(token)
      .then(setDoc)
      .catch(() => setError('Timesheet not found.'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="public-page loading-screen">
        <Loading withOverlay={false} description="Loading timesheet..." />
      </div>
    );
  }

  if (error || !doc) {
    return (
      <div className="public-page">
        <Tile>
          <InlineNotification kind="error" title="Error" subtitle={error} hideCloseButton />
          <Link to="/">← Back to SenseStack</Link>
        </Tile>
      </div>
    );
  }

  const ts = doc.data || {};

  return (
    <div className="public-page">
      <div className="public-header">
        <Link to="/" className="public-brand">SenseStack</Link>
        <Tag type="blue">Timesheet</Tag>
      </div>

      <Tile className="public-document-tile">
        <h1>{ts.title || 'Timesheet'}</h1>
        <div className="timesheet-meta">
          <p><strong>Client:</strong> {ts.clientName}</p>
          <p><strong>Project:</strong> {ts.projectName || '—'}</p>
          <p><strong>Period:</strong> {ts.periodStart} — {ts.periodEnd || 'ongoing'}</p>
          <p><strong>Rate:</strong> ${ts.hourlyRate}/hr</p>
        </div>

        <table className="invoice-view-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Hours</th>
            </tr>
          </thead>
          <tbody>
            {(ts.entries || []).map((entry, i) => (
              <tr key={i}>
                <td>{entry.date}</td>
                <td>{entry.description}</td>
                <td>{entry.hours}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="invoice-view-totals">
          <div><span>Total hours</span><span>{(ts.totalHours || 0).toFixed(2)}</span></div>
          <div className="grand"><span>Total amount</span><span>${(ts.totalAmount || 0).toFixed(2)} AUD</span></div>
        </div>

        {ts.notes && (
          <div className="invoice-view-notes">
            <h4>Notes</h4>
            <p>{ts.notes}</p>
          </div>
        )}
      </Tile>
    </div>
  );
};

export default TimesheetViewPage;
